const store = {
    namespaced: true,
    state() {
        return {
            list: [],
            products: []
        };
    },
    getters: {},
    mutations: {
        setList(state, data) {
            state.list = data;
            this.$cookies.set('favorites', state.list, {
                path: '/',
                maxAge: 60 * 60 * 24 * 365
            });
        },
        toggleItem(state, id) {
            state.list = this.$cookies.get('favorites') || [];

            if (state.list.includes(id)) {
                state.list = state.list.filter(item => item !== id);
            } else {
                state.list.push(id);
            }

            this.$cookies.set('favorites', state.list, {
                path: '/',
                maxAge: 60 * 60 * 24 * 365
            });
        },
        setProducts(state, data) {
            state.products = data;
        }
    },
    actions: {
        updateList({ state, commit, dispatch }) {
            if (!state.list[0]) return;

            return this.$axios
                .patch('/api/v1/user/fav', {
                    goods: state.list
                })
                .then(response => {
                    const data = response.data;
                    const list = data.map(item => item.id);
                    commit('setList', list);
                    dispatch('getLocalProducts');
                    return data;
                })
                .catch(error => {
                    throw error;
                });
        },
        deleteItem({ commit, dispatch }, id) {
            return this.$axios
                .delete(`/api/v1/user/fav/${id}`)
                .then(response => {
                    const data = response.data;
                    const list = data.map(item => item.id);
                    commit('setList', list);
                    dispatch('getLocalProducts');
                    return data;
                })
                .catch(error => {
                    throw error;
                });
        },
        getProducts({ commit, dispatch, state }) {
            return this.$axios
                .get('/general/product-filter', { params: { ids: state.list.join(',') } })
                .then(response => {
                    const data = response.data;
                    commit('setProducts', data);
                    return response;
                })
                .catch(error => {
                    throw error;
                });
        },
        getLocalProducts({ state, commit, rootGetters }) {
            const products = [];
            state.list.forEach(item => {
                const currentProduct = rootGetters['catalog/getCategories']?.data?.products.find(
                    product => product.productId === item
                );

                if (currentProduct) {
                    products.push(currentProduct);
                }
            });
            commit('setProducts', products);
        }
    }
};

export default store;
